export const iconFontAwesomeWritingBlog = (
	<i className="fa-solid fa-blog"></i>
);
